// src/utils/articleMarkdown.ts
//
// מקור אמת יחיד לתוספי ה-Markdown של גוף המאמר.
//
// שלושה מקומות מרנדרים את אותו תוכן: עמוד המאמר הציבורי, התצוגה המקדימה
// שלצד העורך, והתצוגה המקדימה של טיוטה. אם רשימת התוספים תיפרד ביניהם,
// התצוגה המקדימה תחזור לשקר — וזו בדיוק הבעיה שתוקנה. לכן כולם מייבאים
// מכאן, ולא מגדירים רשימה משלהם.
//
// remark-gfm  — טבלאות וזיהוי כתובות אוטומטי.
// remark-breaks — ירידת שורה בודדת הופכת ל-<br>. חובה לשמור: 12 מאמרים
//                 קיימים בנויים כמעט כולם על שברי שורה, והסרתו תקרוס אותם
//                 לפסקה רצה אחת.
//
// הסדר נבדק מול התוכן האמיתי: הטבלה נבנית כראוי ושורות הטבלה כבר לא
// מתפרשות כשברי שורה.

import remarkGfm from "remark-gfm";
import remarkBreaks from "remark-breaks";
import type { PluggableList } from "unified";

export const ARTICLE_REMARK_PLUGINS: PluggableList = [remarkGfm, remarkBreaks];
